export { default as ProductsRenderTypesFilterBadge } from './ProductsRenderTypesFilterBadge';
